import styled from 'styled-components';

import ClientsSearchSelect from '@components/ClientsSearchSelect';

export const Select = styled(ClientsSearchSelect)`
  background-color: white;
  min-width: 300px;
  color: ${({ theme }) => theme.colors.gray.six};
`;
